export default "__VITE_ASSET__95030f86__"